/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M20.9999 21H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.99994 3L3 7.99994M7.99994 3L12.9999 7.99994M7.99994 3V14.6C7.99994 16.8402 7.99994 17.9603 8.43591 18.816C8.81941 19.5686 9.43133 20.1805 10.184 20.564C11.0396 21 12.1597 21 14.3999 21H14.5H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M7.99994 3L3 7.99994M7.99994 3L12.9999 7.99994M7.99994 3V14.6C7.99994 16.8402 7.99994 17.9603 8.43591 18.816C8.81941 19.5686 9.43133 20.1805 10.184 20.564C11.0396 21 12.1597 21 14.3999 21H20.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M7.99994 3L3 7.99994M7.99994 3L12.9999 7.99994M7.99994 3V14.6C7.99994 16.8402 7.99994 17.9603 8.43591 18.816C8.81941 19.5686 9.43133 20.1805 10.184 20.564C11.0396 21 12.1597 21 14.3999 21H20.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 7.99994L7.99994 3V14.6C7.99994 16.8402 7.99994 17.9603 8.43591 18.816C8.81941 19.5686 9.43133 20.1805 10.184 20.564C11.0396 21 12.1597 21 14.3999 21H20.9999M12.9999 7.99994L10.4999 5.49997"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7.99994 3L3 7.99994M7.99994 3L12.9999 7.99994M7.99994 3V14.6C7.99994 16.8402 7.99994 17.9603 8.43591 18.816C8.81941 19.5686 9.43133 20.1805 10.184 20.564C11.0396 21 12.1597 21 14.3999 21H20.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M7.99994 3L3 7.99994M7.99994 3L12.9999 7.99994M7.99994 3V14.6C7.99994 16.8402 7.99994 17.9603 8.43591 18.816C8.81941 19.5686 9.43133 20.1805 10.184 20.564C11.0396 21 12.1597 21 14.3999 21H20.9999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
